export default {
  retiredWarnings: {
    summary: 'Nadradené zariadenie je vyradené z prevádzky',
    details: 'Nadradené zariadenie je vyradené z prevádzky. Toto zariadenie bude po uložení automaticky tiež vyradené z prevádzky.',
  },
};
